import React, { Component } from 'react'
import { BrowserRouter, Match } from 'react-router'
import Category from './pages/Category'
import {style, media, merge} from 'glamor'
import * as colors from '../colors'
import HomeDesktop from './HomeDesktop'

export default class AppDesktop extends Component {

  shouldComponentUpdate(){
    return false
  }


  componentDidMount(){
    document.body.style.overflow = 'hidden'
  }

  componentWillUnmount(){
    document.body.style.overflow = 'auto'
  }

  render(){

    console.log('info', this.props)

    return (
      <div
        {...merge(
          style({
            color: colors.darkGray,
            display: 'flex',
            minHeight: '100vh',
            width: '100%',
            position: 'relative',
            perspective: 500
          })
        )}
      >
        <Match
          direction={-1}
          pattern={
            `(${this.props.pages.reduce((pattern, page)=>{
              return pattern + '|' + page.url
            }, '')})`
          }
          render={(matchProps) => (
            <HomeDesktop
              {...matchProps}
              {...this.props}
            />
          )}
        />


        <Match
          direction={1}
          pattern="/:type/:category"
          render={(matchProps) => (
            <Category
              {...matchProps}
              {...this.props}
            />
          )}
        />

      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/AppDesktop.js
 **/